const rosterList = state => state.rosterList;

const rosterListLoading = state => state.rosterListLoading;

const player = state => state.player;

const playerLoading = state => state.playerLoading;

const image = state => state.image;

const imageLoading = state => state.imageLoading;

const rosterListLimited = state => state.rosterListLimited

export default {
  rosterList,
  rosterListLoading,
  player,
  playerLoading,
  image,
  imageLoading,
  rosterListLimited
};
